module.exports = __webpack_public_path__ + "static/media/simon.9ff69b63.png";